import { DataTable, PageWrapper, STATUSPAGE } from '@repo/ui';
import { GeneralFilters } from 'presentation/app/components/general-filters';
import { useEffect } from 'react';
import { Button, Card, CardBody } from 'reactstrap';

import { makeColumnsGroup } from '../common/columns/columns-list-group';
import { useGroupList } from '../hooks/useGroupList';

const GroupList = () => {
  const {
    listLoadingStatus,
    // filtersDisabled,
    // filterBySemester,
    // filterByCurricularUnit,
    validation,
    paginationMetadata,
    groupsListData,
    // semestersUser,
    // curricularUnitsUser,
    debouncedRequestGetAllActivitiesByStatus,
    navigate,
    getLegends,
    setListLoadingStatus,
    handleSortRemote,
    handleSearchRemote,
    handlePageChange,
    handleRowsPerPageChange,
  } = useGroupList();

  // useEffect
  useEffect(() => {
    const valuesToSubmit = {
      entity: validation.values.entity?.value,
      course: validation.values.course?.value,
      semester: validation.values.semester?.value,
      curricularUnit: validation?.values?.unit?.value,
      // pagination
      page: paginationMetadata.selectedPage,
      length: paginationMetadata.rowsPerPage,
      query: paginationMetadata.searchString,
      order: paginationMetadata.sortDirection,
      orderColumn: paginationMetadata.orderColumn,
    };

    setListLoadingStatus(STATUSPAGE.LOADING);
    debouncedRequestGetAllActivitiesByStatus(valuesToSubmit);
  }, [paginationMetadata, validation.values]);

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum grupo encontrado',
    noDataDescription:
      'Use os filtros acima para pesquisar grupos por nome ou código.',
  };

  return (
    <PageWrapper title={getLegends('GRUPO', true)}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>{getLegends('GRUPO', true)}</h4>
        <Button color="light" onClick={() => navigate('/grupos-arquivados')}>
          <span>Arquivados</span>
          <i className="ri-archive-line mx-1"></i>
        </Button>
      </div>
      <Card>
        <GeneralFilters
          validation={validation}
          additionalDependentInputs={[
            {
              id: 'group',
              isVisible: false,
              isDisabled: false,
              label: 'Grupos',
              options: [],
              placeholder: 'Selecione um grupo',
              onChange: function (e: any): void {
                throw new Error('Function not implemented.');
              },
            },
          ]}
          populateAdditionalDependentInputs={null}
        />
        <CardBody>
          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            canSearch
            pagination
            sortServer
            searchServer
            actions={[
              {
                id: 1,
                name: 'settings',
                label: 'Configurar',
                onPress: (cellProps) => {
                  navigate(`/grupos/configurar/${cellProps.id}`);
                },
                icon: 'ri-equalizer-line',
                classNameColorIcon: 'primary',
              },
            ]}
            paginationServer
            defaultSortAsc={true}
            defaultSortFieldId={1}
            onSort={handleSortRemote}
            data={groupsListData?.data}
            columns={makeColumnsGroup()}
            onSearch={handleSearchRemote}
            onChangePage={handlePageChange}
            paginationTotalRows={groupsListData?.total}
            loading={listLoadingStatus === STATUSPAGE.LOADING}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </CardBody>
      </Card>
    </PageWrapper>
  );
};

export default GroupList;
